// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3mopX","title":"BackImages_title__3tcoX","images":"BackImages_images__i0xX8"};